import React from 'react';
import './HeroSection.css';


class HeroSection extends React.Component{
    
    render() {
        let back = this.props.background;
        let style = {
            backgroundImage :  `url(${back})`
        }
       return (
        <section className="hero-section" style={style}>
           <h1 className="page-title">{this.props.pageTitle}</h1>
        </section>
       );
    }
}
export default HeroSection;